/* istanbul ignore file */
import VueRouter from "vue-router";

export function createRouter(mode = "history") {
    const router = new VueRouter({
        // for component use case, use abstract mode to avoid to change url.
        /* for history mode, need to add server configurations:
        https://router.vuejs.org/guide/essentials/history-mode.html#example-server-configurations
        */
        mode: mode,
        routes: [
            {
                path: "/",
                redirect: "/type"
            },
            {
                path: "/type",
                name: "type",
                component: () => import(/* webpackMode: "eager" */ "@/views/Home/ChooseType.vue"),
                props: () => {
                    return {
                        mwcId: `${router.app.mwcId}.mwc-choose-type`
                    };
                }
            },
            {
                path: "/workflow",
                component: () => import(/* webpackMode: "eager" */ "@/views/NewWorkflow/WorkflowWrapper.vue"),
                children: [
                    {
                        path: "/workflow/AddHoldings/:portfolioNumber",
                        name: "AddHoldings",
                        component: () => import(/* webpackMode: "eager" */ "@/views/NewWorkflow/AddHoldings.vue"),
                        props: () => {
                            return {
                                mwcId: `${router.app.mwcId}.mwc-add-holding`
                            };
                        }
                    },
                    {
                        path: "/workflow/EditAssumptions/:portfolioNumber",
                        name: "EditAssumptions",
                        component: () => import(/* webpackMode: "eager" */ "@/views/NewWorkflow/NewEditAssumptions.vue"),
                        props: () => {
                            return {
                                mwcId: `${router.app.mwcId}.mwc-edit-assumptions`
                            };
                        }
                    },
                    {
                        path: "/workflow/Summary",
                        name: "Summary",
                        component: () => import(/* webpackMode: "eager" */ "@/views//NewWorkflow/Summary.vue"),
                        props: () => {
                            return {
                                mwcId: `${router.app.mwcId}.mwc-summary`
                            };
                        }
                    },
                    {
                        path: "/workflow/BuildReport",
                        name: "BuildReport",
                        component: () => import(/* webpackMode: "eager" */ "@/views/NewWorkflow/BuildReport.vue"),
                        props: () => {
                            return {
                                mwcId: `${router.app.mwcId}.mwc-build-report`
                            };
                        }
                    }
                ]
            },
            // {
            //     path: "/AddHoldings/:portfolioNumber",
            //     name: "AddHoldings",
            //     component: () => import(/* webpackMode: "eager" */ "@/views/NewWorkflow/AddHoldings.vue"),
            //     props: () => {
            //         return {
            //             mwcId: `${router.app.mwcId}.mwc-add-holding`
            //         };
            //     }
            // },
            // {
            //     path: "/EditAssumptions/:portfolioNumber",
            //     name: "EditAssumptions",
            //     component: () => import(/* webpackMode: "eager" */ "@/views/NewWorkflow/NewEditAssumptions.vue"),
            //     props: () => {
            //         return {
            //             mwcId: `${router.app.mwcId}.mwc-edit-assumptions`
            //         };
            //     }
            // },
            // {
            //     path: "/Summary",
            //     name: "Summary",
            //     component: () => import(/* webpackMode: "eager" */ "@/views//NewWorkflow/Summary.vue"),
            //     props: () => {
            //         return {
            //             mwcId: `${router.app.mwcId}.mwc-summary`
            //         };
            //     }
            // },
            // {
            //     path: "/BuildReport",
            //     name: "BuildReport",
            //     component: () => import(/* webpackMode: "eager" */ "@/views/NewWorkflow/BuildReport.vue"),
            //     props: () => {
            //         return {
            //             mwcId: `${router.app.mwcId}.mwc-build-report`
            //         };
            //     }
            // },
            {
                path: "/ReportGenerator",
                name: "ReportGenerator",
                component: () => import(/*webpackMode: "eager" */ "@/views/ReportOption/ReportGenerator.vue"),
                props: () => {
                    return {
                        mwcId: `${router.app.mwcId}.mwc-report-generator`
                    };
                }
            },
            {
                path: "/home",
                name: "home",
                component: () => import(/*webpackMode: "eager" */ "@/views/Home/Home.vue"),
                props: () => {
                    return {
                        mwcId: `${router.app.mwcId}.mwc-hypothetical-home`
                    };
                }
            },
            {
                path: "/error",
                name: "error",
                component: () => import(/*webpackMode: "eager" */ "@/views/ErrorPage.vue"),
                props: true
            },
            {
                path: "*",
                redirect: "/"
            }
        ]
    });
    return router;
}
